import { router } from '@/app/router';
import { captureEvent } from '@/shared/analytics/posthog';
import { useEffect } from 'react';

/**
 * Captures a `$pageview` per resolved TanStack Router location. The library's
 * automatic pageview is disabled (`capture_pageview: false`) because a
 * client-routed SPA emits no browser navigation for route changes — this hook
 * is the single point that fires one instead.
 *
 * Subscribes to the router instance directly (`onResolved`) rather than
 * `useRouterState`, so it works from the analytics wiring that mounts *around*
 * `RouterProvider` (no router context required). The initial location has
 * already resolved by the time this effect runs, so it is captured once up
 * front; the subscription then covers every subsequent navigation.
 */
export function usePageviewTracking(): void {
  useEffect(() => {
    captureEvent('$pageview', { $current_url: window.location.href });

    return router.subscribe('onResolved', () => {
      captureEvent('$pageview', { $current_url: window.location.href });
    });
  }, []);
}
